/* eslint-disable import/prefer-default-export */
// @flow

import Loadable from 'react-loadable';

import LoadingPage from '../main/pages/LoadingPage';

export const LoadablePingPage = Loadable({
  loader: () => import(/* webpackChunkName: "health" */ './pages/PingPage'),
  loading: LoadingPage,
});
